import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import { WindowButton } from '@ff-os/shared-react/components/window/partials/WindowButton';
import { WindowFooter } from '@ff-os/shared-react/components/window/partials/WindowFooter';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { useCloseWindow } from '@ff-os/shared-react/context/window/useWindowContext';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { ColorAttributeDropdownList } from './ColorAttributeDropdownList';

export const ColorAttributeWindow = ({
    variableIds, renderPreview
}: Props) => {

    const [isOpen, setIsOpen] = useState(false);
    const onClose = useCloseWindow(() => setIsOpen(false));
    const { t } = useTranslation();

    return (
        <>
            <WindowButton chevron onClick={() => setIsOpen(true)}>
                {renderPreview()}
            </WindowButton>

            <WindowContext isOpen={isOpen} close={() => setIsOpen(false)}>
                <WindowContext.Header>
                    <WindowHeader previous={onClose}>
                        {t('variables.color')}
                    </WindowHeader>
                </WindowContext.Header>
                <WindowContext.Body>
                    <ColorAttributeDropdownList gap='xs' variableIds={variableIds} />
                </WindowContext.Body>
                <WindowContext.Footer>
                    <WindowFooter justify='end'>
                        <Button onClick={onClose}>
                            {t('commons.save')}
                        </Button>
                    </WindowFooter>
                </WindowContext.Footer>
            </WindowContext>
        </>
    );
};

type Props = {
    renderPreview: () => JSX.Element;
    variableIds: string[];
};